// Enregistre le service worker (voir public/service-worker.js) uniquement
// en production et sur navigateur compatible, sans jamais bloquer le
// rendu de l'app si ça échoue (best-effort).
export function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production") return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {
      // silencieux : l'app doit fonctionner même si le SW échoue à s'installer
    });
  });
}
